// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--3aEmS","isLight":"styles-module--isLight--1RUD4","isFixed":"styles-module--isFixed--1-vio"};